"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _container = _interopRequireDefault(require("../../core/container"));
var _CategoryQualifiers = _interopRequireDefault(require("./CategoryQualifiers"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
// *******************************************************************************
// Main Component
// *******************************************************************************
var _ref = /*#__PURE__*/_react.default.createElement("br", null);
class Qualifiers extends _react.Component {
  render() {
    if (!this.props.selectionCategories) return;
    return this.props.selectionCategories.filter(cat => !cat.isExpired).map(cat => /*#__PURE__*/_react.default.createElement(_container.default, {
      key: cat.refCode
    }, _ref, /*#__PURE__*/_react.default.createElement("h2", null, cat.description), /*#__PURE__*/_react.default.createElement(_CategoryQualifiers.default, {
      yearID: +this.props.yearID,
      classes: this.props.classes,
      selectionQualifiers: this.props.selectionQualifiers.filter(qual => qual.selectionCategoryRef === cat.refCode)
    })));
  }
}
// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref2 = {
  refCode: true,
  description: true,
  isExpired: true
};
var _ref3 = _mergeBqlQueries({}, _CategoryQualifiers.default.partialQueries.Classes);
var _ref4 = _mergeBqlQueries({
  selectionCategoryRef: true
}, _CategoryQualifiers.default.partialQueries.SelectionQualifiers);
var _default = exports.default = (0, _reactBicycle.connect)(Qualifiers, props => ({
  "refCodes(codeType:\"selectioncategory\") as selectionCategories": _ref2,
  "refCodes(codeType:\"event\") as classes": _ref3,
  ["selectionQualifiers(yearID:" + JSON.stringify(+props.yearID) + ")"]: _ref4
}));